/* URLS */
export const NODES_DOCS_URL =
    'https://lotus.filecoin.io/docs/developers/hosted-lotus/'

/* WALLET TYPES */
export const HD_WALLET = 'HD_WALLET'
export const SINGLE_KEY = 'SINGLE_KEY'

/* LOGIN OPTIONS */
export const LEDGER = 'LEDGER'
export const METAMASK = 'METAMASK'
export const IMPORT_MNEMONIC = 'IMPORT_MNEMONIC'
export const CREATE_MNEMONIC = 'CREATE_MNEMONIC'
export const IMPORT_SINGLE_KEY = 'IMPORT_SINGLE_KEY'

/* NETWORK VARS */
export const MAINNET_PATH_CODE = 461
export const TESTNET_PATH_CODE = 1

/* FILECOIN APP VERSION MIN */
export const LEDGER_VERSION_MAJOR = 0
export const LEDGER_VERSION_MINOR = 22
export const LEDGER_VERSION_PATCH = 0

export const FILSNAP = 'npm:@chainsafe/filsnap'
